const privacy = `
<p style="text-align:center">鼓楼数字政协隐私政策</p>
<p>发布日期：2022年6月15日</p>
<p>生效日期：2022年6月15日</p>
<p>更新日期：2024年6月06日</p>
<p>提示条款</p>
<p>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。</p>
<p>您在使用鼓楼数字政协提供的各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后开始使用相关产品或服务。您开始使用鼓楼数字政协各项产品或服务，即表示您已充分理解并同意本政策。如对本政策内容有任何疑问、意见或建议，请通过本政策提供的联系方式及时与我们联系。</p>
<p>第一部分 定义</p>
<p>鼓楼数字政协：指鼓楼数字政协向用户提供服务的产品载体（包括并不限于APP/网站/公众号等）。</p>
<p>鼓楼数字政协服务提供者：指鼓楼数字政协的网络及软件技术服务提供者南京同橙教育有限公司。</p>
<p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
<p>个人敏感信息：包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
<p>个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
<p>除另有约定外，本政策所用定义与《鼓楼数字政协服务协议》中的定义具有相同的含义。</p>
<p>第二部分 法律声明</p>
<p>一、权利归属</p>
<p>鼓楼数字政协所有的产品、服务、技术与所有应用程序或其组件/功能（以下或简称“技术服务”）的知识产权均归属于鼓楼数字政协所有或归其权利人所有。 除非另行声明，鼓楼数字政协拥有鼓楼数字政协在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经鼓楼数字政协许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载鼓楼数字政协网站内的任何内容）。被授权浏览、复制、打印和传播属于鼓楼数字政协产品和服务内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。</p>
<p>二、责任限制</p>
<p>鼓楼数字政协用户在鼓楼数字政协移动客户端、官方主页以及开放平台上自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，鼓楼数字政协用户须对其提供的任何信息依法承担全部责任。</p>
<p>鼓楼数字政协转载作品出于传递更多信息之目的，并不意味鼓楼数字政协赞同其观点或证实其内容的真实性。</p>
<p>鼓楼数字政协在此提示，您在使用鼓楼数字政协产品及服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用鼓楼数字政协产品及服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，鼓楼数字政协不对您使用鼓楼数字政协产品及服务的用途和目的承担任何责任。</p>
<p>第三部分 隐私政策</p>
<p>本隐私政策部分将帮助您了解以下内容：</p>
<p>一、我们如何收集和使用您的个人信息</p>
<p>二、我们如何使用Cookie和同类技术</p>
<p>三、我们如何共享、转让、公开披露您的信息</p>
<p>四、我们如何保护您的信息</p>
<p>五、我们可能发送的信息</p>
<p>六、您如何管理您的信息</p>
<p>七、我们如何处理未成年人的信息</p>
<p>八、您的个人信息如何在全球范围转移</p>
<p>九、本隐私政策如何更新</p>
<p>十、如何联系我们</p>
<p>十一、应用使用的第三方SDK及其功能</p>
<p>鼓楼数字政协隐私政策</p>
<p>发布日期：2022年6月15日</p>
<p>生效日期：2022年6月15日</p>
<p>提示条款</p>
<p>您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。</p>
<p>您在使用鼓楼数字政协提供的各项产品或服务前，请您务必仔细阅读并透彻理解本政策，在确认充分理解并同意后开始使用相关产品或服务。您开始使用鼓楼数字政协各项产品或服务，即表示您已充分理解并同意本政策。如对本政策内容有任何疑问、意见或建议，请通过本政策提供的联系方式及时与我们联系。</p>
<p>第一部分 定义</p>
<p>鼓楼数字政协：指鼓楼数字政协向用户提供服务的产品载体（包括并不限于APP/网站/公众号等）。</p>
<p>鼓楼数字政协服务提供者：指鼓楼数字政协的网络及软件技术服务提供者南京同橙教育有限公司。</p>
<p>个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</p>
<p>个人敏感信息：包括身份证件号码、手机号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</p>
<p>个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</p>
<p>除另有约定外，本政策所用定义与《鼓楼数字政协服务协议》中的定义具有相同的含义。</p>
<p>第二部分 法律声明</p>
<p>一、权利归属</p>
<p>鼓楼数字政协所有的产品、服务、技术与所有应用程序或其组件/功能（以下或简称“技术服务”）的知识产权均归属于鼓楼数字政协所有或归其权利人所有。 除非另行声明，鼓楼数字政协拥有鼓楼数字政协在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经鼓楼数字政协许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载鼓楼数字政协网站内的任何内容）。被授权浏览、复制、打印和传播属于鼓楼数字政协产品和服务内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。</p>
<p>二、责任限制</p>
<p>鼓楼数字政协用户在鼓楼数字政协移动客户端、官方主页以及开放平台上自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，鼓楼数字政协用户须对其提供的任何信息依法承担全部责任。</p>
<p>鼓楼数字政协转载作品出于传递更多信息之目的，并不意味鼓楼数字政协赞同其观点或证实其内容的真实性。</p>
<p>鼓楼数字政协在此提示，您在使用鼓楼数字政协产品及服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用鼓楼数字政协产品及服务从事侵犯他人名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，鼓楼数字政协不对您使用鼓楼数字政协产品及服务的用途和目的承担任何责任。</p>
<p>第三部分 隐私政策</p>
<p>本隐私政策部分将帮助您了解以下内容：</p>
<p>一、我们如何收集和使用您的个人信息</p>
<p>二、我们如何使用Cookie和同类技术</p>
<p>三、我们如何共享、转让、公开披露您的信息以及接入的第三方</p>
<p>四、我们如何保护您的信息</p>
<p>五、我们可能发送的信息</p>
<p>六、您如何管理您的信息</p>
<p>七、我们如何处理未成年人的信息</p>
<p>八、您的个人信息如何在全球范围转移</p>
<p>九、本隐私政策如何更新</p>
<p>十、如何联系我们</p>
<p>一、我们如何收集和使用您的个人信息</p>
<p>（一）我们如何收集您的信息</p>
<p>1、您主动提供给我们的信息</p>
<p>（1）注册成为我们的用户</p>
<p>我们通过鼓楼数字政协为您提供服务。为使用我们的服务，您需要注册为用户，须提供必要的个人信息（例如：真实姓名、手机号码、用户名信息等）。</p>
<p>（2）其他相关信息</p>
<p>您在使用我们的服务时，提供或发布的信息，包括但不限于与您个人相关的内容（例如：文章、动态、评论或图片等）或授权我们使用的您通讯录联系人等相关信息。</p>
<p>2、其他用户主动提供给我们的信息</p>
<p>其他用户在使用我们的服务时，提供或发布的与您相关的信息，包括但不限于与您个人相关的内容（例如：文章、动态、评论或图片等）或授权我们使用的通讯录联系人等相关信息中可能包含您的信息。</p>
<p>3、我们在您使用服务时收集的信息</p>
<p>在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的内容展示和搜索结果， 同时基于文件缓存、下载，日志存储等基础运营需求，我们需要获得您的公共区域读写权限，并可能会自动收集您的使用情况并存储为网络日志信息，包括：</p>
<p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符、安卓ID、IMSI、MAC地址等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS/北斗位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）以及设备状态信息（例如设备应用安装列表）。</p>
<p>日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间、您访问的网页记录、通话状态信息等。</p>
<p>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
<p>我们将获取您手机的摄像头权限用以帮助您使用已登录的移动设备扫描网页二维码的形式登录网页端产品或扫描鼓楼数字政协内的其他二维码来完成相关操作。</p>
<p>当您需要发送语音或视频、进行对单方或多方的音、视频通话或会议，我们需要获取您的麦克风和摄像头权限。</p>
<p>当您需要在使用鼓楼数字政协部分功能中发送定位时，我们需要获取您的地理位置信息。</p>
<p>当您将文件存储在我的云盘中时，我们需要获取您的存储权限帮助您将终端设备本地的文件上传或将云端文件下载至终端设备。</p>
<p>一、我们如何收集和使用您的个人信息</p>
<p>（一）我们如何收集您的信息</p>
<p>1、您主动提供给我们的信息</p>
<p>（1）注册成为我们的用户</p>
<p>我们通过鼓楼数字政协为您提供服务。为使用我们的服务，您需要注册为用户，须提供必要的个人信息（例如：真实姓名、手机号码、用户名信息等）。</p>
<p>（2）其他相关信息</p>
<p>您在使用我们的服务时，提供或发布的信息，包括但不限于与您个人相关的内容（例如：文章、动态、评论或图片等）或授权我们使用的您通讯录联系人等相关信息。</p>
<p>2、其他用户主动提供给我们的信息</p>
<p>其他用户在使用我们的服务时，提供或发布的与您相关的信息，包括但不限于与您个人相关的内容（例如：文章、动态、评论或图片等）或授权我们使用的通讯录联系人等相关信息中可能包含您的信息。</p>
<p>3、我们在您使用服务时收集的信息</p>
<p>在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的内容展示和搜索结果， 同时基于文件缓存、下载，日志存储等基础运营需求，我们需要获得您的公共区域读写权限，并可能会自动收集您的使用情况并存储为网络日志信息，包括：</p>
<p>设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符、安卓ID、IMSI、MAC地址等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS/北斗位置信息以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）以及设备状态信息（例如设备应用安装列表）。</p>
<p>日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间、您访问的网页记录、通话状态信息等。</p>
<p>请注意，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。</p>
<p>我们将获取您手机的摄像头权限用以帮助您使用已登录的移动设备扫描网页二维码的形式登录网页端产品或扫描鼓楼数字政协内的其他二维码来完成相关操作。</p>
<p>当您需要发送语音或视频、进行对单方或多方的音、视频通话或会议，我们需要获取您的麦克风和摄像头权限。</p>
<p>当您需要在使用鼓楼数字政协部分功能中发送定位时，我们需要获取您的地理位置信息。</p>
<p>当您将文件存储在我的云盘中时，我们需要获取您的存储权限帮助您将终端设备本地的文件上传或将云端文件下载至终端设备。</p>
<p>当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。</p>
<p>4、根据相关法律法规等，以下情形中，我们可能会收集、使用您的个人信息而无需征求您的授权：</p>
<p>（1）与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等公共利益直接相关的；</p>
<p>（2）与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
<p>（3）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
<p>（4）所收集的个人信息是您自行向社会公众公开的；</p>
<p>（5）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
<p>（6）出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
<p>（7）法律法规规定的其他情形。</p>
<p>（二）我们如何使用您的信息</p>
<p>我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途：</p>
<p>1、向您提供服务；</p>
<p>2、满足您的个性化需求；</p>
<p>3、进行产品开发和服务优化；</p>
<p>4、安全保障；</p>
<p>5、管理软件；</p>
<p>6、邀请您参与有关我们服务的调查</p>
<p>二、我们如何使用Cookie和同类技术</p>
<p>您使用我们的服务时，我们会在您的计算机或移动设备上存储名为Cookies的小数据文件。Cookies通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务质量及优化用户体验。</p>
<p>我们不会将Cookies用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器都设有阻止Cookies的功能。但如果您这么做，您可能需要在每一次访问我们的网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有一定影响。</p>
<p>三、我们如何共享、转让、公开披露您的信息以及接入的第三方</p>
<p>（一）共享</p>
<p>我们不会与鼓楼数字政协服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：</p>
<p>1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</p>
<p>2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
<p>（二）转让</p>
<p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
<p>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
<p>2、在鼓楼数字政协服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</p>
<p>（三）公开披露</p>
<p>我们仅会在以下情况下，公开披露您的个人信息：</p>
<p>1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
<p>2、如果我们确定您出现违反法律法规或严重违反鼓楼数字政协相关协议及规则的情况，或为保护鼓楼数字政协用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及鼓楼数字政协已对您采取的措施。</p>
<p>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
<p>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
<p>1、与国家安全、国防安全有关的；</p>
<p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
<p>3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；</p>
<p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
<p>5、您自行向社会公众公开的个人信息；</p>
<p>6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p>
<p>请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</p>
<p>四、我们如何保护您的信息</p>
<p>（一）我们已采取合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。</p>
<p>（二）我们从组织建设、制度设计、人员管理、产品技术等方面多维度保障整个系统的安全性。目前，我们的重要信息系统已经通过【ICP备案】等认证。</p>
<p>（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求）。</p>
<p>（四）互联网并非绝对安全的环境，我们强烈建议您接入服务时要使用安全的系统和通讯网络。</p>
<p>请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息。即使您删除共享信息，有关信息仍可能在您删除前由其他用户或不受我们控制的非关联第三方独立地复制或储存。请您更加谨慎地考虑上传、发布和交流的信息内容。</p>
<p>请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络鼓楼数字政协客服，以便我们根据您的申请采取相应措施。</p>
<p>（五）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
<p>同时，我们还将按照监管部门要求，上报个人信息安全事件的处理情况。</p>
<p>五、我们可能发送的信息</p>
<p>1、您在使用我们的服务时，我们可能使用您的信息发送电子邮件、短信、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。</p>
<p>2、我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</p>
<p>六、您如何管理您的信息</p>
<p>您享有您账户的使用权。我们享有账户的所有权。在使用中，您不应以任何方式私自转让账户使用权，也不应以任何形式盗用他人账户。账户的行为将被视为账户注册用户的行为。</p>
<p>您可以通过以下方式访问及管理您的个人信息：</p>
<p>（一）访问您的个人信息</p>
<p>1、您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</p>
<p>账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息，您可以通过登录您的账号执行此类操作。</p>
<p>2、如果您无法通过上述路径访问该等个人信息，您可以随时通过鼓楼数字政协提供的客服电话或鼓楼数字政协APP中的【意见反馈】与我们取得联系。</p>
<p>3、对于您在使用我们的产品或服务过程中产生的其他个人信息，我们将根据本条“第（五）款响应您的上述请求”中的相关安排向您提供。</p>
<p>（二）更正或补充您的个人信息</p>
<p>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。</p>
<p>（三）删除您的个人信息</p>
<p>1、您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。</p>
<p>2、在以下情形中，您可以向我们提出删除个人信息的请求：</p>
<p>（1）如果我们处理个人信息的行为违反法律法规；</p>
<p>（2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
<p>（3）如果我们处理个人信息的行为严重违反了与您的约定。</p>
<p>3、当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
<p>（四）如何注销您的账户</p>
<p>1、由于鼓楼数字政协的业务特殊性，暂不支持个人注销账户，您可以和所在党组织进行申请，由您的所在党组织联系鼓楼数字政协服务提供者注销您的账户。</p>
<p>2、 在您主动注销账户之后，我们将停止为您提供产品或服务，根据适用法律的要求删除您的个人信息，或其他匿名化处理。</p>
<p>（五）响应您的上述请求</p>
<p>1、为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
<p>2、 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
<p>3、在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
<p>（1）与国家安全、国防安全有关的；</p>
<p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
<p>（3）与犯罪侦查、起诉、审判和执行判决等有关的；</p>
<p>（4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
<p>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</p>
<p>（6）涉及商业秘密的；</p>
<p>（7）存在可能无法响应您请求的其他情况的。</p>
<p>七、我们如何处理未成年人的信息</p>
<p>如您为未成年人，我们要求您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</p>
<p>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享此信息。</p>
<p>八、您的个人信息如何在全球范围转移</p>
<p>我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</p>
<p>1、法律法规有明确规定；</p>
<p>2、获得您的明确授权；</p>
<p>3、您的个人主动行为。</p>
<p>针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。</p>
<p>九、本隐私政策如何更新</p>
<p>1、未经您明确同意，我们不会限制您按照本政策所应享有的权利。</p>
<p>2、对于重大变更（包括但不限于我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等），我们还会提供更为显著的通知。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的政策约束。</p>
<p>十、如何联系我们</p>
<p>若有如下情形，您可以拨打联系电话【025-85509799】与我们联系：</p>
<p>1、如对本协议内容有任何疑问、意见或建议；</p>
<p>2、如对鼓楼数字政协的产品和服务有任何疑问、意见或建议。</p>
<p>十一、应用使用的第三方SDK及其功能</p>
<p>为保障鼓楼数字政协相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关第三方及关联方SDK在目录中列明。请注意，第三方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>
<p>应用使用的第三方SDK及其功能</p>
<p>1.腾讯浏览服务（腾讯X5浏览器）</p>
<p>第三方名称：深圳腾讯计算机系统有限公司</p>
<p>使用目的：在app中打开H5页面</p>
<p>处理方式：通过去标识化、加密传输和处理的安全处理方式</p>
<p>收集个人信息类型：国际设备识别码（IMEI）、国际移动用户识别码（IMSI）、网卡地址（MAC Address）、设备ID（ANDROID ID）、用户机型、屏幕尺寸、操作系统版本号、目标API（targetAPI）、网络类型(ApnType)、网络变化监听广播以及 Wifi的mac地址</p>
<p>第三方用户隐私协议或官网链接：https://x5.tencent.com/tbs/guide/develop.html</p>
<p>2.com.bun.miitmdid、com.zui.opendeviceidlibrary</p>
<p>第三方名称：移动安全联盟 OAID</p>
<p>使用目的：设备制造商、设备型号、设备品牌，用于判断终端调用接口。设备网络运营商名称，用于判断虚拟机环境。APP 包名，用于校验签名</p>
<p>处理方式：移动智能终端补充设备标识体系与 SDK 严格遵守我国《网络安全法》、《数据安全法》和《电信和互联网用户个人信息保护规定》等相关法律法规和《信息安全技术 个人信息安全规范》等国家标准要求。SDK 不会主动收集任何数据，只在 APP 调用时获取以下数据，用于本地判断，不会进行任何网络传输</p>
<p>收集个人信息类型：获取oaid设备信息</p>
<p>第三方用户隐私协议或官网链接：http://www.msa-alliance.cn/col.jsp?id=122</p>
<p>3.com.amap.api, com.loc, com.autonavi:</p>
<p>第三方名称：高德开放平台</p>
<p>使用目的：获取用户当前位置，用于定位扫码签到。</p>
<p>收集个人信息类型：存储的个人文件、位置信息、读取手机状态和身份、网络信息、传感器信息、Android ID</p>
<p>第三方用户隐私协议：https://lbs.amap.com/pages/privacy/</p>
`;









const serve = 
`
<p style="text-align:center">服务协议</p>
<p>首部及导言</p>
<p>欢迎使用同橙《鼓楼数字政协》软件及服务！</p>
<p>为使用同橙《鼓楼数字政协》软件（以下简称“本软件”）及服务，用户应当阅读并遵守《同橙《鼓楼数字政协》软件许可及服务协议》（以下简称“本协议”）。请用户务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示用户注意。</p>
<p>除非用户已阅读并接受本协议所有条款，否则用户无权下载、安装或使用本软件及相关服务。用户的下载、安装、使用、获取《鼓楼数字政协》服务管理帐号及《鼓楼数字政协》最终用户帐号（以下简称：《鼓楼数字政协》帐号）、登录等行为即视为用户已阅读并同意上述协议的约束。</p>
<p>一、协议的范围</p>
<p>协议适用主体范围</p>
<p>本协议是用户与南京同橙教育科技有限公司之间关于用户下载、安装、使用、复制本软件，以及使用同橙相关服务所订立的协议。“同橙”是指南京同橙教育科技有限公司及其相关服务可能存在的运营关联单位。“《鼓楼数字政协》用户”是指登录、使用《鼓楼数字政协》软件及服务并获得管理权限的个人或组织，在本协议中更多地称为“你”。“最终用户”是指你所创建的《鼓楼数字政协》的个人用户。前述“《鼓楼数字政协》用户”及“最终用户”统称为“用户”或“所有用户”。</p>
<p>二、关于本服务</p>
<p>2.1 本服务的内容</p>
<p>本服务内容是指同橙向用户提供的履职服务工具（以下简称“《鼓楼数字政协》”），支持单人、多人参与，查阅资讯、查询提案、签到等服务（以下简称“本服务”）。</p>
<p>2.2 本服务的形式</p>
<p>2.2.1 用户使用本服务需要下载同橙《鼓楼数字政协》客户端软件，同橙将向用户提供《鼓楼数字政协》的账号、管理权限、使用功能和使用说明等服务，并尽应有之努力保障本服务的正常运行。</p>
<p>2.2.2 本服务中同橙《鼓楼数字政协》软件提供包括但不限于Windows、Mac、iOS、Android等多个应用版本（具体以同橙提供的版本为准），用户必须选择与所安装终端设备相匹配的软件版本，同橙会不断更新应用版本等。</p>
<p>2.3 本服务许可的范围</p>
<p>2.3.1 同橙给予用户一项不可转让的、非排他性的许可，以使用本软件。</p>
<p>2.3.2 本条及本协议其他条款未明示授权的其他一切权利仍由同橙保留，用户在行使这些权利时须另外取得同橙的书面许可。同橙如果未行使前述任何权利，并不构成对该权利的放弃。</p>
<p>三、软件的获取</p>
<p>3.1 用户可以直接从同橙的网站上获取本软件，也可以从得到同橙授权的第三方获取。</p>
<p>3.2 如果用户从未经同橙授权的第三方获取本软件或与本软件名称相同的安装程序，同橙无法保证该软件能够正常使用，并对因此给用户造成的损失不予负责。</p>
<p>四、软件的安装与卸载</p>
<p>4.1 同橙可能为不同的终端设备开发了不同的软件版本，用户应当根据实际情况选择下载合适的版本进行安装。</p>
<p>4.2 下载安装程序后，用户需要按照该程序提示的步骤正确安装。</p>
<p>4.3 为提供更加优质、安全的服务，在本软件安装时同橙可能推荐用户安装其他软件，用户可以选择安装或不安装。</p>
<p>4.4 如果用户不再需要使用本软件或者需要安装新版软件，可以自行卸载。</p>
<p>五、软件的更新</p>
<p>5.1 为了改善用户体验、完善服务内容，同橙将不断努力开发新的服务，并为用户不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
<p>5.2 为了保证本软件及服务的安全性和功能的一致性，同橙有权不经向用户特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
<p>5.3 本软件新版本发布后，旧版本的软件可能无法使用。同橙不保证旧版本软件及相应的客户服务继续可用，请用户随时核对并下载最新版本。</p>
<p>5.4用户同意，同橙可能通过公告、更新日志等方式向用户通知软件更新情况，但同橙不需向用户特别通知。</p>
<p>六、用户信息及个人信息保护</p>
<p>6.1 保护用户信息是同橙的一项基本原则，同橙将会采取合理的措施保护用户的信息。除法律法规规定的情形外，未经用户许可同橙不会向第三方公开、透露用户信息。同橙对相关信息采用专业加密存储与传输方式，保障用户信息的安全。</p>
<p>6.2 用户在注册帐号或使用本服务的过程中，需要提供一些必要的个人信息，例如：为向用户提供帐号注册服务或进行用户身份识别，需要填写手机号码；通话功能需要用户授权访问手机通讯录等。若国家法律法规或政策有特殊规定的，用户需要提供真实的身份信息。若用户提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
<p>6.3 一般情况下，用户可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，用户可能无法修改注册时提供的初始注册信息及其他验证信息。</p>
<p>6.4 同橙将运用各种安全技术和程序建立完善的管理制度来保护用户的个人信息，以免遭受未经授权的访问、使用或披露。</p>
<p>6.5你在上传和管理组织成员名称、照片、手机号等个人信息时，请确保你已经事先获得组织成员的明确同意，仅收集为运营及功能实现目的而必需的用户信息，且已充分告知组织成员相关数据收集的目的、范围及使用方式等。</p>
<p>6.6 《鼓楼数字政协》用户应当建立信息安全保护制度并对最终用户进行信息安全教育，包括但不限于：将管理权限交予适当的人选；合理设定相关人员的管理权限；提醒或要求最终用户注意信息安全和帐号安全，防止帐号被他人使用而导致的信息泄露。</p>
<p>6.7 未经用户的同意，同橙不会向同橙以外的任何公司、组织和个人披露用户的个人信息，但法律法规另有规定的除外。</p>
<p>6.8 同橙非常重视对未成年人个人信息的保护。若用户是18周岁以下的未成年人，在使用同橙的服务前，应事先取得用户家长或法定监护人的书面同意。</p>
<p>6.9 就你使用本软件及服务过程中所产生的及你所收集或被提供的任何个人信息（“个人信息”），你应根据所有可适用法律法规使用本服务，并依约履行你在本协议下的义务。本协议所指的“可适用法律法规”是指你通过本服务所提供的信息、服务或前述信息、服务可被接收的国家、地区的法律、法规、规章、规范性文件、政策。你承诺：</p>
<p>6.9.1遵守不时修订的所有可适用的隐私和数据保护的法律法规，包括适用于个人信息的法律法规，并向我们提供必要信息以证明你已遵守前述法律法规及本协议约定；</p>
<p>6.9.2 仅就使用本软件及本服务之目的使用、处理用户的个人信息，除非最终用户另行授权或同意；</p>
<p>6.9.3明确、准确地向你的最终用户描述你所收集的个人信息以及如何使用、向第三方分享这些信息等；</p>
<p>6.9.4采取适宜的技术及系统的安全措施，以保护个人信息免遭未经授权访问或使用，并对前述安全措施的有效性进行定期测试；</p>
<p>6.9.5 确保所有有权访问个人信息的人员都受保密义务的约束；</p>
<p>6.9.6出现任何未经授权的访问或使用个人信息的情况下，及时向同橙、最终用户和相关数据保护机构汇报；</p>
<p>6.9.7尽可能协助同橙应对最终用户根据可适用法律法规行使其权利的要求。</p>
<p>七、主权利义务条款</p>
<p>7.1 帐号使用规范</p>
<p>7.1.1 你在使用本服务前需要注册一个《鼓楼数字政协》服务管理帐号，并向最终用户分配最终用户帐号，为验证最终用户所属组织，保障《鼓楼数字政协》帐号安全并获得提供服务所必要的用户信息，最终用户需通过手机号码及帐号验证后方能使用《鼓楼数字政协》帐号。</p>
<p>7.1.2 《鼓楼数字政协》帐号的所有权归同橙公司所有，用户完成申请注册手续后，仅获得《鼓楼数字政协》帐号的使用权，用户不得赠与、借用、租用、转让或售卖《鼓楼数字政协》帐号或者以其他方式许可他人使用。</p>
<p>7.1.3用户应当按照法律法规和服务要求，按相应页面的提示准确提供并及时更新用户的资料，以使之真实、及时，完整和准确。用户承诺不得冒充他人进行注册，不得未经许可为他人注册，不得以可能误导其他用户的方式注册帐号，不得使用可能侵犯他人权益的用户名进行注册（包括但不限于涉嫌商标权、名誉权侵权等），否则同橙有权注销该帐号。</p>
<p>7.1.4 用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在你怀疑他人在使用你的帐号时，你应立即通知同橙公司。</p>
<p>7.1.5 用户注册《鼓楼数字政协》帐号后如果长期不登录该帐号，同橙有权回收该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。</p>
<p>7.1.6用户确认，在用户完成注册程序或以其他同橙允许的方式实际使用服务时，用户应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若用户不具备前述主体资格，请勿使用本服务，否则用户及用户的监护人应承担因此而导致的一切后果，且同橙有权注销（永久冻结）用户的账户，给同橙造成损失的，同橙有权向用户追偿。如你代表一家公司或其他法律主体进行注册或以其他同橙允许的方式实际使用本服务的，则你声明和保证，你有权使该公司或该法律主体受本协议的约束。</p>
<p>7.2 用户注意事项</p>
<p>7.2.1 用户理解并同意：为了向用户提供有效的服务，本软件会利用用户终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。</p>
<p>7.2.2 你理解并同意：本软件会让最终用户查询到本企业或组织内其他最终用户的信息，但管理员可以通过管理权限限制最终用户的信息查阅权限。在使用本服务管理你的最终用户信息时，你应当：</p>
<p>7.2.2.1 充分告知最终用户使用本软件及本服务对用户信息、内容相关影响的政策规定；</p>
<p>7.2.2.2 确保在使用本服务过程中对用户信息、内容的使用和处理遵从可适用的法律法规的要求;</p>
<p>7.2.2.3 应对并处理你与最终用户就用户信息、内容相关的，或因你未完全履行该条款所产生的所有争议及纠纷，并独立承担由此而产生的一切法律责任。</p>
<p>7.2.4 用户理解并同意同橙将会尽其商业上的合理努力保障用户在本软件及服务中的数据存储安全，但是，同橙并不能就此提供完全保证，包括但不限于以下情形：</p>
<p>7.2.4.1 同橙不对用户在本软件及服务中相关数据的删除或储存失败负责；</p>
<p>7.2.4.2 同橙有权根据实际情况自行决定用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本软件及服务中的相关数据；</p>
<p>7.2.4.3 如果用户停止使用本软件及服务或服务被终止、取消，同橙可以从服务器上永久地删除你的数据。服务停止、终止或取消后，同橙没有义务向用户返还任何数据。</p>
<p>7.2.5 用户在使用本软件及服务时，须自行承担如下来自同橙不可掌控的风险内容，包括但不限于：</p>
<p>7.2.5.1 由于不可抗拒因素可能引起的用户信息丢失、泄漏等风险；</p>
<p>7.2.5.2 用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；</p>
<p>7.2.5.3 用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；</p>
<p>7.2.5.4 用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</p>
<p>7.2.5.5 由于网络信号不稳定、网络带宽小等网络原因，所引起的同橙《鼓楼数字政协》登录失败、资料同步不完整、页面打开速度慢等风险。</p>
<p>7.3 《鼓楼数字政协》API</p>
<p>7.3.1 同橙在《鼓楼数字政协》平台向你提供了对《鼓楼数字政协》帐号功能进行开发的各项服务（以下简称“开发服务”），你应按照本协议和开发者文档等规范和技术要求自行开发，你应对使用该开发服务所产生的内容自行独立承担责任，如因此造成同橙或第三方损失的，你应当赔偿。</p>
<p>7.3.2 未经同橙书面许可，你不得将开发服务用于任何其他目的及用途，或委托、授权及泄漏给任何第三方为任何方式的使用。</p>
<p>7.3.3 你使用开发服务所进行的开发全过程除应符合《鼓楼数字政协》开发文档的明确要求外，还应符合相关法律法规、技术规范标准以及同橙在技术、安全等方面的相关要求， 以确保相关《鼓楼数字政协》帐号安全、稳定地运营。本协议使用规范同时包含本协议条款、《鼓楼数字政协》相关开发文档以及其他相应接口的开发者文档，你使用开发服务应当同时遵守上述规范，否则同橙有权依照本协议采取处理措施。</p>
<p>7.3.4 你在使用开发服务过程中不得从事以下行为，也不得为以下行为提供便利，该等行为包括但不限于：</p>
<p>7.3.4.1 在未获得同橙书面许可的情况下，以任何方式使用同橙URL地址、本服务外的其他技术接口等；</p>
<p>7.3.4.2 为任何其他用户自动登录到《鼓楼数字政协》提供代理身份验证凭据；</p>
<p>7.3.4.3 自动将浏览器窗口定向到其他网页；</p>
<p>7.3.4.4侵犯他人的合法权益，包括但不限于：著作权、商标权、专利权等知识产权及其他相关权益；</p>
<p>7.3.4.5 其他同橙认为不应该、不适当的行为或内容。</p>
<p>7.3.5 你使用开发服务通过《鼓楼数字政协》帐号向其他用户提供服务的过程中，对于其他用户或最终用户数据的收集、保存、使用等必须满足以下要求：</p>
<p>7.3.5.1 必须事先获得其他用户或最终用户的明确同意，且仅应当收集为运营及功能实现目的而必需的用户数据，同时应当告知其他用户或最终用户相关数据收集的目的、范围及使用方式等，保障其他用户及最终用户的知情权和选择权；</p>
<p>7.3.5.2 你对收集的相关用户数据，必须采取必要的保护措施，防止用户数据被盗、泄漏等；</p>
<p>7.4 第三方产品和服务</p>
<p>7.4.1 用户在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。同橙和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</p>
<p>7.4.2 因用户使用本软件或要求同橙提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供（包括但不限于通话功能：可能通过融云平台提供的即时通讯服务），同橙不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与同橙无关，同橙不承担任何责任。</p>
<p>7.4.3 用户理解并同意，同橙有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，同橙承诺在推广过程中严格按照本协议约定保护用户信息。</p>
<p>八、用户行为规范</p>
<p>8.1 信息内容规范</p>
<p>8.1.1 本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于《鼓楼数字政协》帐号头像、名称、用户说明等注册信息，或文字、语音、图片等发送、回复、公告和相关链接页面，以及其他使用《鼓楼数字政协》帐号或本软件及服务所产生的内容。</p>
<p>8.1.2 用户理解并同意，同橙一直致力于为用户提供文明健康、规范有序的网络环境，你不得利用《鼓楼数字政协》帐号或本软件及服务制作、复制、发布、传播如下干扰《鼓楼数字政协》软件正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</p>
<p>8.1.2.1 发布、传送、传播、储存违反国家法律法规禁止的内容：</p>
<p>（1）违反宪法确定的基本原则的；</p>
<p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
<p>（3）损害国家荣誉和利益的；</p>
<p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
<p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
<p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
<p>（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>
<p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
<p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
<p>（10）以非法民间组织名义活动的；</p>
<p>（11）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</p>
<p>（12）含有法律、行政法规禁止的其他内容的。</p>
<p>8.1.2.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
<p>8.1.2.3 涉及他人隐私、个人信息或资料的；</p>
<p>8.1.2.4 发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；</p>
<p>8.1.2.5 其他违反法律法规、政策及公序良俗、社会公德或干扰《鼓楼数字政协》正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
<p>8.2 软件使用规范</p>
<p>8.2.1 除非法律允许或同橙书面许可，用户使用本软件过程中不得从事下列行为：</p>
<p>8.2.1.1 删除本软件及其副本上关于著作权的信息；</p>
<p>8.2.1.2 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
<p>8.2.1.3 对同橙拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
<p>8.2.1.4 对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非同橙经授权的第三方工具/服务接入本软件和相关系统；</p>
<p>8.2.1.5 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
<p>8.2.1.6 通过非同橙开发、授权的第三方软件、插件、外挂、系统，登录或使用同橙软件及服务，或制作、发布、传播上述工具；</p>
<p>8.2.1.7 自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</p>
<p>8.2.1.8 其他未经同橙明示授权的行为。</p>
<p>8.2.2 用户理解并同意，基于用户体验、《鼓楼数字政协》或相关服务平台运营安全、平台规则要求及健康发展等综合因素，同橙有权选择提供服务的对象，有权决定功能设置，有权决定功能开放、数据接口和相关数据披露的对象和范围。如果用户的行为存在以下情形，同橙有权视具体情况中止或终止提供本服务，包括但不限于：</p>
<p>8.2.2.1 违反法律法规、本协议规定或不符合同橙其他管理要求的；</p>
<p>8.2.2.2 从事影响本软件服务体验的行为；</p>
<p>8.2.2.3 继续使用可能存在安全隐患的，包括但不限于对用户自身或第三方人身、财产构成安全隐患的，对公共安全构成安全隐患的等情形。</p>
<p>8.3 服务运营规范</p>
<p>除非法律允许或同橙书面许可，用户使用本服务过程中不得从事下列行为：</p>
<p>8.3.1 提交、发布虚假信息，或冒充、利用他人名义的；</p>
<p>8.3.2 诱导其他用户点击链接页面或分享信息的；</p>
<p>8.3.3 虚构事实、隐瞒真相以误导、欺骗他人的；</p>
<p>8.3.4 侵害他人名誉权、肖像权、知识产权、商业秘密等合法权益的；</p>
<p>8.3.5 未经同橙书面许可利用《鼓楼数字政协》帐号和任何功能，进行推广或互相推广的；</p>
<p>8.3.6 利用《鼓楼数字政协》帐号或本软件及服务从事任何违法犯罪活动的；</p>
<p>8.3.7 制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的；</p>
<p>8.3.8 其他违反法律法规规定、侵犯其他用户合法权益、干扰产品正常运营或同橙未明示授权的行为。</p>
<p>8.4 对自己行为负责</p>
<p>用户充分理解并同意，用户必须为自己《鼓楼数字政协》帐号下的一切行为负责，包括用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。同橙无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>
<p>8.5 违约处理</p>
<p>8.5.1 如果同橙发现或收到他人举报或投诉用户违反本协议约定的，同橙有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。</p>
<p>8.5.2 用户理解并同意，同橙有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。</p>
<p>8.5.3 用户理解并同意，因用户违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，用户应当独立承担责任；同橙因此遭受损失的，用户也应当一并赔偿。</p>
<p>九、终端安全责任</p>
<p>9.1 用户理解并同意，本软件同大多数软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁用户的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，用户应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</p>
<p>9.2 用户不得制作、发布、使用、传播用于窃取《鼓楼数字政协》帐号及他人个人信息、财产的恶意程序。</p>
<p>9.3 维护软件安全与正常使用是同橙和用户的共同责任，同橙将按照行业标准合理审慎地采取必要技术措施保护你的终端设备信息和数据安全，但是用户承认和同意同橙并不能就此提供完全保证。</p>
<p>十、第三方软件或技术</p>
<p>10.1 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</p>
<p>10.2 本软件如果使用了第三方的软件或技术，同橙将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，你应当遵守这些要求。如果用户没有遵守这些要求，该第三方或者国家机关可能会对用户提起诉讼、罚款或采取其他制裁措施，并要求同橙给予协助，用户应当自行承担法律责任。</p>
<p>10.3 如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，同橙不承担任何责任。同橙不对第三方软件或技术提供客服支持，若用户需要获取支持，请与第三方联系。</p>
<p>十一、免责与责任限制</p>
<p>11.1 用户理解并同意：本软件及本服务按“如是”的状态提供，同橙对本服务不作任何明示或暗示的保证，包括但不限于对本服务的可适用性、持续性等。</p>
<p>11.2 用户理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断，因此而引发的损害及后果，同橙不承担任何责任。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、风暴等以及社会事件如战争、动乱、政府行为等。</p>
<p>11.3 在适用法律允许的范围内，同橙在任何情况下（不论何种原因）均不承担如下责任：（A）任何间接的、故意的、惩罚性的、附带的、惩戒性的、特殊的或后果性的损害赔偿; （B）业务或机会损失; （C）收入损失; （D）利润损失; （E）商誉损失;（F）内容损失; 或（G）数据丢失。</p>
<p>十二、知识产权声明</p>
<p>12.1 同橙是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，同橙享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</p>
<p>12.2未经同橙或相关权利人书面同意，用户不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
<p>十三、其他</p>
<p>13.1 用户使用本软件即视为用户已阅读并同意受本协议的约束。同橙有权在必要时修改本协议条款。同橙可能会以包括但不限于在相关服务页面展示、网页公告、网页提示、电子邮箱、手机短信、常规的信件传送、用户注册使用本服务的帐号管理系统内发送站内信等方式中的一种或多种，向用户送达关于本服务的各种规则、通知、提示等信息，用户可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果用户继续使用本软件，即视为用户已接受修改后的协议。如果用户不接受修改后的协议，应当停止使用本软件。</p>
<p>用户同意，任何由于电子邮箱、手机号码、通讯地址等信息错误或其他不可归咎于同橙的原因，导致用户未收到相关规则、通知、提示等信息的，均不影响该等信息对用户所产生的法律效力，且用户应受其约束，由此产生的一切后果及责任由用户自行承担。</p>
<p>13.2 本协议签订地为中华人民共和国广东省深圳市南山区。</p>
<p>13.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
<p>13.4 若用户和同橙之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，用户同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
<p>13.5 本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议含义解释的依据。</p>
<p>13.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。（正文完）</p>
<p>南京同橙教育科技有限公司</p>
`;

export default {
    privacy:privacy,
    serve:serve
}